import { ListPartnerNewsAdminResponseSchema } from './list-partner-news-admin.schema';
export const listPartnerNewsAdminContract = {
    method: 'GET',
    path: '/api/v2/admin/partner-news',
    description: 'List all partner news, drafts included',
    responseSchema: ListPartnerNewsAdminResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only'
        }
    }
};

//# sourceMappingURL=list-partner-news-admin.contract.js.map